const ValidationErrors = {
  required: "Ce champ est obligatoire",
  isEMail: "Format d'email invalide",
  isInt: "Veuillez fournir un nombre entier valide",
  isNumeric: "Veuillez fournir un nombre valide",
  isUrl: "Veuillez fournir une adresse URL valide",
  isLength: (length) => `Le champ doit faire ${length} caractères`,
  maxLength: (length) => `Veuillez fournir au plus ${length} caractères`,
  min: (min) => `Le nombre doit être supérieur à ${min}`,
  max: (max) => `Le nombre doit être inférieur à ${max}`,
  validPhoneNumber: "Veuillez saisir un numéro de téléphone valide.",
  validMobilePhoneNumber:
    "Veuillez saisir un numéro de téléphone mobile valide.",
  lowerAlphaDash:
    "Le champ doit être composé uniquement de lettres minuscules, chiffres et de tirets",
  insecuredPassword: "Veuillez saisir un mot de passe sécurisé",
  endDateAfter: "La date de fin doit être supérieure à la date de début",
  validFrequency: "Veuillez saisir un format de CRON valide",
};

export default ValidationErrors;
